export default __webpack_public_path__ + "static/media/wallpaper_bg4.2ba84c0f.png";